module.exports = __webpack_public_path__ + "img/gif_empleabilidad.31498904.gif";